import React from 'react';
import { FlexColumnWidth100 } from '../../../../../components/ui/Content';

const RegFormWrapper = ({ children }: React.PropsWithChildren) => {
	return (
		<FlexColumnWidth100 className='reg-container' style={{ gap: '35px' }}>
			{children}
		</FlexColumnWidth100>
	);
};

export default RegFormWrapper;
